import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, computed } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { ProjectUserAssociationCreateDocument } from '@/gql/graphql';
import {
  BAlert,
  BButton,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BModal,
  BSpinner,
} from 'bootstrap-vue-next';
import { SHARING_USER_ROLES, SharingModeSelectOptions } from '@/constants';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectUserAssociationCreate',
  props: {
    show: { type: Boolean },
    projectId: {},
    projectName: {}
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

const show = computed<boolean>(() => {
  return props.show;
});

// --- Component state ---
const userEmail = ref('');
const userRole = ref(SHARING_USER_ROLES.VIEWER);
const description = ref('');

// --- Mutation: Create Project-User Association ---
const mutationInProgress = ref<boolean>(false);
const mutationError = ref<string | null>(null);
const mutationShowSuccess = ref<boolean>(false);

const {
  mutate: executeMutation,
  onDone: onMutationDone,
  onError: onMutationError,
} = useMutation(ProjectUserAssociationCreateDocument);

onMutationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.projectUserAssociationCreate) {
    console.debug(
      'Project-user association created:',
      res.data.projectUserAssociationCreate
    );
    mutationShowSuccess.value = true;
    setTimeout(() => {
      mutationShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 1000);
  } else {
    mutationError.value = 'Project-user association failed: ' + res.data;
    console.error('Project-user association failed:', res.data);
  }
});

onMutationError((err) => {
  console.error('Error creating project-user association:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handle component actions ---
function onProjectUserAssociationRequested() {
  if (!userEmail.value) {
    mutationError.value = 'User email not provided';
    console.error('User email not provided');
    return;
  }
  console.debug(
    'Creating project-user association, project ',
    props.projectId,
    'user',
    userEmail.value
  );

  mutationInProgress.value = true;
  mutationError.value = null;
  executeMutation({
    projectId: props.projectId,
    userEmail: userEmail.value,
    userRole: userRole.value,
    description: description.value,
  });
}

function closeModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((show).value = $event)),
      onHide: closeModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "plus",
          class: "me-2"
        }),
        _cache[6] || (_cache[6] = _createTextVNode(" Share project ", -1))
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: closeModal
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "primary",
          disabled: mutationInProgress.value || mutationShowSuccess.value,
          onClick: onProjectUserAssociationRequested
        }, {
          default: _withCtx(() => [
            (mutationInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _cache[9] || (_cache[9] = _createTextVNode(" Sharing Project ", -1)),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (mutationShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _cache[10] || (_cache[10] = _createTextVNode(" Sharing Successful ", -1)),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, " Share Project "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_unref(BFormGroup), {
            label: "User e-mail",
            "label-for": "user-email",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormInput), {
                modelValue: userEmail.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userEmail).value = $event)),
                id: "user-email",
                name: "user-email",
                placeholder: "Enter user e-mail",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BFormGroup), {
            label: "User role",
            "label-for": "user-role",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormSelect), {
                id: "user-role",
                modelValue: userRole.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userRole).value = $event)),
                options: _unref(SharingModeSelectOptions),
                class: "form-control mb-2"
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BFormGroup), {
            label: "Description",
            "label-for": "description",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormTextarea), {
                id: "description",
                modelValue: description.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((description).value = $event)),
                class: "form-control mb-2"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("option", { value: "viewer" }, "Viewer", -1),
                  _createElementVNode("option", { value: "editor" }, "Editor", -1)
                ]))]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BAlert), {
            modelValue: mutationError.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mutationError).value = $event)),
            variant: "danger",
            dismissible: "",
            class: "mt-3",
            onDismissed: _cache[4] || (_cache[4] = ($event: any) => (mutationError.value = null))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mutationError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})